import { render, staticRenderFns } from "./LogMails.vue?vue&type=template&id=28c06cb0&scoped=true&"
import script from "./LogMails.vue?vue&type=script&lang=js&"
export * from "./LogMails.vue?vue&type=script&lang=js&"
import style0 from "./LogMails.vue?vue&type=style&index=0&id=28c06cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c06cb0",
  null
  
)

export default component.exports